import apiSlice from "../api/apiSlice";

export const usersApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getStudents : builder.query({
            query: () => '/users?role=student'
        }),
        checkUserRole : builder.query({
            query: (email) => `/users?email=${email}`
           })
    })
})

export const { useGetStudentsQuery, useCheckUserRoleQuery } = usersApi;